<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
const items: ComputedRef<number> = computed(() => (isMobile ? 1 : 2));
</script>

<template>
  <ul :class="['lawyer-slider-skeleton', { _mobile: isMobile }]">
    <li v-for="item in items" :key="item" class="lawyer-slider-skeleton__item">
      <div v-if="item" class="lawyer-slider-skeleton__header">
        <Skeleton
          width="100%"
          :height="isMobile ? '80px' : '150px'"
          :max-width="isMobile ? '92px' : '133px'"
        />
        <Skeleton width="100%" height="171px" />
      </div>
      <Skeleton class="lawyer-slider-skeleton__button" width="150px" height="45px" />
    </li>
  </ul>
</template>

<style lang="less" scoped>
.lawyer-slider-skeleton {
  display: flex;
  justify-content: space-between;
  gap: 100px;

  &__header {
    display: flex;
    justify-content: space-between;
    gap: @size-x4;
  }

  &__item {
    .flex-column(@size-x4);
    .box-shadow();

    width: 100%;
    height: 289px;
    padding: @size-x5;
  }

  &__button {
    margin-left: auto;
  }
}
</style>
